module.exports = __webpack_public_path__ + "img/lock.a5de0ae3.png";